module.exports = __webpack_public_path__ + "static/relocation-236b65dc8662b4e663933626357d141e.jpg";